import { useState } from "react";

const short = (n) => (n || "—").split(" ").slice(0, 2).join(" ");

function cellFor(bout, key) {
  if (!bout || bout.status !== "completed") return null;
  const mine = bout.participant_a === key ? bout.score_for : bout.score_against;
  const other = bout.participant_a === key ? bout.score_against : bout.score_for;
  const win = bout.participant_a === key ? bout.result === "V" : bout.result === "D";
  return { mine, other, win };
}

/** Matrice classica del girone + elenco assalti (ordine FIE) + classifica del girone */
export function PoolCard({ pool, hits, nameOf, onOpenBout }) {
  const [view, setView] = useState("matrix");
  const keys = pool.participant_keys;
  const byPair = {};
  pool.bouts.forEach((b) => { byPair[`${b.participant_a}|${b.participant_b}`] = b; byPair[`${b.participant_b}|${b.participant_a}`] = b; });
  const rank = Object.fromEntries(pool.ranking.map((r) => [r.key, r]));
  const done = pool.bouts.filter((b) => b.status === "completed").length;

  return (
    <div className="bg-white border border-zinc-200 rounded-md overflow-hidden" data-testid={`pool-${pool.number}`}>
      <div className="px-4 py-3 border-b border-zinc-100 flex items-center justify-between gap-2 flex-wrap">
        <div className="font-heading font-semibold">Girone {pool.number} <span className="text-xs text-zinc-500 font-mono font-normal">· {keys.length} atleti · {done}/{pool.bouts.length} assalti · {hits} stoccate</span></div>
        <div className="flex border border-zinc-200 rounded overflow-hidden text-xs">
          <button data-testid={`pool-${pool.number}-view-matrix`} onClick={() => setView("matrix")} className={`px-3 py-1.5 ${view === "matrix" ? "bg-black text-white" : "hover:bg-zinc-50"}`}>Matrice</button>
          <button data-testid={`pool-${pool.number}-view-list`} onClick={() => setView("list")} className={`px-3 py-1.5 ${view === "list" ? "bg-black text-white" : "hover:bg-zinc-50"}`}>Assalti</button>
        </div>
      </div>

      {view === "matrix" ? (
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse" data-testid={`pool-${pool.number}-matrix`}>
            <thead>
              <tr className="bg-zinc-50">
                <th className="text-left px-3 py-2 font-medium text-xs text-zinc-500 min-w-[160px]">Atleta</th>
                {keys.map((k, i) => <th key={k} className="w-12 px-1 py-2 font-mono text-xs text-zinc-500">{i + 1}</th>)}
                <th className="px-2 py-2 text-xs text-zinc-500 font-medium">V</th>
                <th className="px-2 py-2 text-xs text-zinc-500 font-medium">V/M</th>
                <th className="px-2 py-2 text-xs text-zinc-500 font-medium">SD</th>
                <th className="px-2 py-2 text-xs text-zinc-500 font-medium">SR</th>
                <th className="px-2 py-2 text-xs text-zinc-500 font-medium">Diff</th>
                <th className="px-2 py-2 text-xs text-zinc-500 font-medium">Pos</th>
              </tr>
            </thead>
            <tbody>
              {keys.map((rk, ri) => {
                const r = rank[rk] || {};
                return (
                  <tr key={rk} className="border-t border-zinc-100">
                    <td className="px-3 py-1.5 whitespace-nowrap"><span className="font-mono text-xs text-zinc-400 mr-2">{ri + 1}</span>{short(nameOf(rk))}</td>
                    {keys.map((ck) => {
                      if (ck === rk) return <td key={ck} className="bg-zinc-800" />;
                      const b = byPair[`${rk}|${ck}`];
                      const c = cellFor(b, rk);
                      return (
                        <td key={ck} className="p-0 text-center">
                          <button data-testid={`cell-${rk}-${ck}`} onClick={() => b && onOpenBout(b)} className={`w-12 h-10 font-mono text-sm transition ${c ? (c.win ? "bg-emerald-50 text-emerald-800 font-semibold" : "bg-red-50 text-red-700") : "text-zinc-300 hover:bg-zinc-100"}`}>
                            {c ? `${c.win ? "V" : "D"}${c.mine}` : "·"}
                          </button>
                        </td>
                      );
                    })}
                    <td className="text-center font-mono px-2">{r.V ?? 0}</td>
                    <td className="text-center font-mono px-2 text-xs">{(r.vm ?? 0).toFixed(3)}</td>
                    <td className="text-center font-mono px-2">{r.hits_for ?? 0}</td>
                    <td className="text-center font-mono px-2">{r.hits_against ?? 0}</td>
                    <td className={`text-center font-mono px-2 ${(r.diff ?? 0) > 0 ? "text-emerald-700" : (r.diff ?? 0) < 0 ? "text-red-600" : ""}`}>{(r.diff ?? 0) > 0 ? "+" : ""}{r.diff ?? 0}</td>
                    <td className="text-center font-heading font-bold px-2" data-testid={`pool-${pool.number}-place-${rk}`}>{r.place ?? "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="divide-y divide-zinc-100" data-testid={`pool-${pool.number}-list`}>
          {[...pool.bouts].sort((a, b) => (a.order || 0) - (b.order || 0)).map((b, i) => {
            const done = b.status === "completed";
            const aWin = done && b.result === "V";
            return (
              <button key={b.id} data-testid={`pool-bout-${b.id}`} onClick={() => onOpenBout(b)} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left hover:bg-zinc-50">
                <span className="font-mono text-xs text-zinc-400 w-5">{i + 1}</span>
                <span className={`flex-1 truncate text-right ${aWin ? "font-semibold" : ""}`}>{short(nameOf(b.participant_a))}</span>
                <span className={`font-mono px-2 py-0.5 rounded text-sm min-w-[64px] text-center ${done ? "bg-zinc-900 text-white" : "bg-zinc-100 text-zinc-400"}`}>{done ? `${b.score_for} – ${b.score_against}` : "da fare"}</span>
                <span className={`flex-1 truncate ${done && !aWin ? "font-semibold" : ""}`}>{short(nameOf(b.participant_b))}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
